import React from "react";
import vi from "../../../assets/common/vi.svg";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";

// check input validation
export const CFV = (key, msg, errors) => (
  <div style={{ color: "red", marginBottom: "0px" }}>
    {errors && errors[key] ? (
      msg
    ) : Object.keys(errors).length > 0 ? (
      <img src={vi} alt={"vi"} style={{ width: "20px", marginRight: "0px" }} />
    ) : (
      <div style={{ height: "20px" }} />
    )}
  </div>
);

export const copyToClipBoard = async (copyMe) => {
  try {
    await navigator.clipboard.writeText(copyMe);
    toast.info("הועתק בהצלחה!");
  } catch (err) {
    toast.error("העתקה נכשלה, יש לפנות למנהל המערכת");
  }
};

export const days = (date_1, date_2) => {
  let difference = date_1.getTime() - date_2.getTime();
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
  return parseInt(TotalDays);
};

export const parseIsoDate = (date) =>
  date.toISOString().replace(/T.*/, "").split("-").reverse().join("/");

export const dateFormat = (date) =>
  date.replace(/T.*/, "").split("-").reverse().join("/");

export const handleClickScroll = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "center" });
  }
};

export const addAlpha = (color, opacity) => {
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + _opacity.toString(16).toUpperCase();
};

export const exportToCSV = (csvData, fileName) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + ".xlsx");
};

export const normalizeGuestNameForCompare = (name) => {
  if (name == null) return "";
  return String(name).replace(/\s+/g, " ").trim();
};

const parseExcelAcceptCell = (v) => {
  if (v === undefined || v === null || v === "") return null;
  const n = Number(v);
  return Number.isNaN(n) ? null : n;
};

const systemAcceptNumber = (g) => {
  if (g == null) return null;
  if (g.accept === null || g.accept === undefined || g.accept === "")
    return null;
  const n = Number(g.accept);
  return Number.isNaN(n) ? null : n;
};

/** קריאת קובץ ייצוא תבנית: שורות מ־A3, עמודה A שם, B אישור */
export const parseWeddingInvitationsExportWorkbook = (wb) => {
  const sheetName = wb.SheetNames.includes("הזמנות")
    ? "הזמנות"
    : wb.SheetNames[0];
  const ws = wb.Sheets[sheetName];
  if (!ws) return new Map();
  const rows = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "" });
  const byName = new Map();
  for (let i = 2; i < rows.length; i++) {
    const row = rows[i] || [];
    const name = normalizeGuestNameForCompare(row[0]);
    if (!name) continue;
    byName.set(name, {
      excelAccept: parseExcelAcceptCell(row[1]),
      displayName: String(row[0]).trim(),
    });
  }
  return byName;
};

/**
 * השוואת קובץ ייצוא קודם (עמודה B) ל־guest.accept הנוכחי לפי שם.
 * מחזיר שורות טקסט להצגה + אורחים שאישרו במערכת ולא מופיעים בקובץ.
 */
export const compareWeddingExportToGuests = (wb, guests) => {
  const excelByName = parseWeddingInvitationsExportWorkbook(wb);
  const guestList =
    guests && !Array.isArray(guests) ? Object.values(guests) : guests || [];
  const excelKeys = new Set(excelByName.keys());
  const lines = [];
  for (const g of guestList) {
    if (!g) continue;
    const k = normalizeGuestNameForCompare(g.name);
    if (!k || !excelKeys.has(k)) continue;
    const ex = excelByName.get(k);
    const sysNorm = systemAcceptNumber(g);
    if (ex.excelAccept !== sysNorm) {
      const exStr = ex.excelAccept === null ? "ריק" : String(ex.excelAccept);
      const syStr = sysNorm === null ? "ריק" : String(sysNorm);
      lines.push(`${g.name} באקסל ${exStr} אבל במערכת ${syStr}`);
    }
  }
  const newSinceExport = [];
  for (const g of guestList) {
    if (!g) continue;
    const k = normalizeGuestNameForCompare(g.name);
    if (!k) continue;
    if (!(g.accept != null && Number(g.accept) > 0)) continue;
    if (!excelKeys.has(k)) newSinceExport.push(g);
  }
  return { lines, newSinceExport };
};

export const compareWeddingExportFromArrayBuffer = (buffer, guests) => {
  const wb = XLSX.read(buffer, { type: "array" });
  return compareWeddingExportToGuests(wb, guests);
};

/** ייצוא תבנית הזמנות לרשימת אורחים (למשל רק „חדשים מאז”) */
export const exportWeddingInvitationsTemplateForGuestList = async (
  confirmedGuests,
  fileName = "הזמנות_תבנית.xlsx",
) => {
  try {
    if (!confirmedGuests || confirmedGuests.length === 0) {
      toast.warning("אין אורחים לייצוא");
      return;
    }
    const base = process.env.PUBLIC_URL || "";
    const res = await fetch(`${base}/wedding_invitations_template_he-IL.xls`);
    if (!res.ok) {
      toast.error("לא ניתן לטעון את תבנית האקסל");
      return;
    }
    const buf = await res.arrayBuffer();
    const wb = XLSX.read(buf, { type: "array" });
    const sheetName = wb.SheetNames[0];
    const ws = wb.Sheets[sheetName];
    const rows = confirmedGuests.map((g) => [
      g.name ?? "",
      g.accept != null && g.accept !== "" ? Number(g.accept) : "",
      "כלה",
      g.closeness ?? "",
      g.phone ?? "",
    ]);
    XLSX.utils.sheet_add_aoa(ws, rows, { origin: "A3" });
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(
      data,
      fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`,
    );
  } catch (e) {
    console.error(e);
    toast.error("שגיאה בייצוא הקובץ");
  }
};

/** ייצוא לתבנית הזמנות חיצונית: כל האורחים עם accept חיובי; עמודות A–E מתוך התבנית ב-public */
export const exportWeddingInvitationsTemplateHeIL = async (guests) => {
  const guestList =
    guests && !Array.isArray(guests) ? Object.values(guests) : guests || [];
  const confirmed = guestList.filter(
    (g) => g != null && g.accept != null && Number(g.accept) > 0,
  );
  if (confirmed.length === 0) {
    toast.warning("אין אורחים שאישרו הגעה");
    return;
  }
  await exportWeddingInvitationsTemplateForGuestList(
    confirmed,
    "הזמנות_תבנית.xlsx",
  );
};

export const getImageUrl = () =>
  "https://secret-mqr-upload.s3.eu-central-1.amazonaws.com/callUp/";

export const getImageUrl2 = () =>
  "https://secret-mqr-upload.s3.eu-central-1.amazonaws.com/callup/";

export const msg4 = `לקוח יקר זו הודעה אוטומטית. תהליך וידוא ההגעה הסתיים ועליך להסדיר תשלום. לשם כך יש להיכנס למערכת, תפריט, לו״ז, לבחור ב״הסדרת תשלום״ ולעקוב אחר ההוראות`;
export const msg4B = `לקוח יקר, תהליך וידוא ההגעה קרוב לסיומו וזה הרגע להסדיר תשלום 🙏\nנהוג לקזז את עלות השירות מהמתנות באשראי במידה וזה מוסכם מבחינתך אין צורך להתייחס להודעה זו\n\nאם תרצו לשלם עכשיו הסכום מופיע במערכת -> תפריט -> לוז -> הסדרת תשלום.\n\n*ניתן לשלם בביט או העברה בנקאית*\n\n*נא לא להעביר ביט למספר הזה כי זה טלפון מוקד, תאמרו לנו איך נוח לכם לשלם ונרשום לכם את הפרטים*`;
export const msg4nC = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\nנראה כי לא עשיתם מתנות באשראי וממש חבל על הכסף שתפסידו, אם תרצו שנסביר לכם למה תאמרו ואם בכל זאת אתם לא רוצים אז אנא להסדיר תשלום דרך המערכת, תפריט, לו״ז, לבחור ב״הסדרת תשלום״ ולעקוב אחר ההוראות. 🙏`;
export const msg4nBS = `לקוח יקר, תהליך וידוא ההגעה קרוב לסיומו וזה הרגע להסדיר תשלום 🙏\nנהוג לקזז את עלות השירות מהמתנות באשראי אך נראה כי לא עשיתם וממש חבל על הכסף שתפסידו, הסברנו את חשיבות השירות בתחילת התהליך אבל אולי עכשיו לאור התוצאות תרצו שכן לקחת את השירות בסופו של דבר, וגם לא אם לא אז בבקשה נא להסדיר את התשלום\n\nהסכום מופיע במערכת -> תפריט -> לוז -> הסדרת תשלום.\n\n*ניתן לשלם בביט או העברה בנקאית*\n\n*נא לא להעביר ביט למספר הזה כי זה טלפון מוקד, תאמרו לנו איך נוח לכם לשלם ונרשום לכם את הפרטים*`;
export const aviadPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לאביעד במספר 0503064555 ולהסדיר תשלום עבור השירות 🙏`;
export const liorWDPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לליאור במספר 0523665635 ולהסדיר תשלום עבור השירות 🙏`;
export const yosefPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות ליוסף במספר 0504077789 ולהסדיר תשלום עבור השירות 🙏`;
export const TipTopPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לבן במספר 0527007397 ולהסדיר תשלום עבור השירות 🙏`;
export const TomerPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לבן במספר 0506654051 ולהסדיר תשלום עבור השירות 🙏`;
export const PolPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לפול במספר 0502692682 ולהסדיר תשלום עבור השירות 🙏`;
export const RazPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות לרז במספר 0585958777 ולהסדיר תשלום עבור השירות 🙏`;
export const igalPmPayment = `לקוח יקר, תהליך וידוא ההגעה הסתיים.\n
יש לפנות ליגאל במספר 0505533440 ולהסדיר תשלום עבור השירות 🙏`;

export const links = {
  BeSimple: "https://callup.ltd/v/besimple/index.html",
  DIY: "https://callup.ltd/v/diy/index.html",
  TipTop: "https://callup.ltd/v/tiptop/index.html",
  "מארגנת החתונות": "https://callup.ltd/v/wd/index.html",
  "משחק הכיסאות": "https://callup.ltd/v/chairsgame/index.html",
  TomerIsakov: "https://callup.ltd/v/tomer/index.html",
  "דובי הפקות": "https://callup.ltd/v/dubi/index.html",
};
